import {useHistory} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import moment from "moment-timezone";
import {getExpiry} from "../util/jwt";
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import {LayoutSplashScreen} from "../../_metronic/layout";
import LoginComponent from "../pages/Authentication/LoginComponent";
import {useTranslation} from "react-i18next";

export const AuthGuard = ({children, redirection = false}) => {
    const {t} = useTranslation();
    const history = useHistory();

    const authSelector = useSelector(state => state.authentication);
    const authStatus = useSelector(state => state.authentication.status);
    const contextChallenges = useSelector(state => state.context.challenges);
    const contextSelector = useSelector(state => state.context);
    const contextStatus = useSelector(state => state.context.status);

    const [canAccess, setCanAccess] = useState(null);
    const dispatch = useDispatch();

    let currentMinutes = moment().minutes();
    const [isContextLoading, setIsContextLoading] = useState(false);

    useEffect(() => {
        if (contextStatus.type === "succeeded") {
            setIsContextLoading(false);
        }
        if (contextStatus.type === "loading") {
            setIsContextLoading(true);
        }
    }, [contextStatus]);

    useEffect(() => {
        const token = authSelector.token || authSelector.externalToken;
        if (token && contextStatus.type) {
            if (getExpiry(token) < 0) {
                // SweetAlert.fire({icon: "info", title: "Session expired"}).then(() => {
                setCanAccess(false);

                dispatch({type: "CLEAR_STORE"});
                // });
            } else {
                if (contextSelector.credential) {
                    setCanAccess(true);
                } else {
                    Swal.fire({text: t("AUTH.MESSAGE.CREDENTIAL_NOT_ALLOWED")}).then(() => {
                        setCanAccess(false);
                        dispatch({type: "CLEAR_STORE"});
                    });
                }
            }
        } else {
            setCanAccess(false);
        }
    }, [authSelector.token, authSelector.externalToken]);

    useEffect(() => {
        const token = authSelector.token || authSelector.externalToken;
        if (token && (!contextChallenges || !contextChallenges.length)) {
            if (authStatus.type === "succeeded" && contextStatus.type === "succeeded") {
                if (!getExpiry(token) < 0 && getExpiry(token) < 1000 * 60 * 5) {
                    SweetAlert.fire({icon: "info", title: "Session expired"}).then(() => {
                        setCanAccess(false);
                        dispatch({type: "CLEAR_STORE"});
                    });
                    // SweetAlert.fire({icon: "info", title: "Session will expire in 5 minutes"});
                    // dispatch(renewToken()) //Maybe refresh token?
                }
            }
        }
    }, [currentMinutes]);

    //if block, appears Login component from auth on each page
    if (!isContextLoading && canAccess === false) {
        if (redirection) {
            history.push("/auth/login");
        } else {
            return <LoginComponent />;
        }
    }
    if (!isContextLoading && canAccess === true) {
        return children;
    }
    return <LayoutSplashScreen />;
};
